import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "./firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import "./TournamentsList.css"; // Import styles

const TournamentsList = () => {
  const navigate = useNavigate();
  const [tournaments, setTournaments] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchTournaments();
  }, []);

  const fetchTournaments = async () => {
    try {
      const tournamentsRef = collection(db, "tournaments");
      const tournamentsSnap = await getDocs(tournamentsRef);
      const tournamentList = await Promise.all(
        tournamentsSnap.docs.map(async (docSnap) => {
          const registeredSnap = await getDocs(
            collection(db, "tournaments", docSnap.id, "registered")
          );
          return {
            id: docSnap.id,
            ...docSnap.data(),
            registeredCount: registeredSnap.size,
          };
        })
      );
      setTournaments(tournamentList);
    } catch (err) {
      console.error("Failed to fetch tournaments", err);
      setTournaments([]);
    }
  };

  const deleteTournament = async (id) => {
    if (window.confirm("Are you sure you want to delete this tournament?")) {
      await deleteDoc(doc(db, "tournaments", id));
      setTournaments((prev) =>
        prev.filter((tournament) => tournament.id !== id)
      );
    }
  };

  const filteredTournaments = useMemo(() => {
    if (!search.trim()) return tournaments;
    const query = search.toLowerCase();
    return tournaments.filter((tournament) => {
      const name = String(tournament.tournamentName || "").toLowerCase();
      const game = String(tournament.gameId || "").toLowerCase();
      return name.includes(query) || game.includes(query);
    });
  }, [search, tournaments]);

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Tournaments</h1>
          <p>Track registrations, brackets, and live results.</p>
        </div>
        <div className="page-actions">
          <input
            className="search-input"
            type="search"
            placeholder="Search tournaments or games"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          <button
            className="button primary"
            type="button"
            onClick={() => navigate("/tournaments/new")}
          >
            Create tournament
          </button>
        </div>
      </div>

      {filteredTournaments.length === 0 ? (
        <div className="card empty-state">
          <div className="empty-title">No tournaments found</div>
          <div className="empty-subtitle">Start by creating a tournament.</div>
        </div>
      ) : (
        <div className="tournament-grid">
          {filteredTournaments.map((tournament) => (
            <div key={tournament.id} className="tournament-card">
              <div className="tournament-banner">
                {tournament.tournamentBanner ? (
                  <img
                    src={tournament.tournamentBanner}
                    alt={tournament.tournamentName}
                  />
                ) : (
                  <div className="tournament-banner-placeholder">
                    Banner pending
                  </div>
                )}
              </div>
              <div className="tournament-info">
                <div className="tournament-title">
                  {tournament.tournamentName || "Untitled tournament"}
                </div>
                <div className="tournament-meta">
                  <span>{tournament.gameId || "Unknown game"}</span>
                  <span>Prize: ₹{tournament.prizePool || 0}</span>
                </div>
                <div className="tournament-meta">
                  <span>Registered: {tournament.registeredCount || 0}</span>
                  <span>Type: {tournament.type || "Team"}</span>
                </div>
              </div>
              <div className="tournament-actions">
                <button
                  className="button primary"
                  type="button"
                  onClick={() => navigate(`/tournaments/manage/${tournament.id}`)}
                >
                  Manage
                </button>
                <button
                  className="button ghost"
                  type="button"
                  onClick={() => deleteTournament(tournament.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TournamentsList;
